import React, {PropsWithChildren} from 'react';
import {FeatureHeaderCell, FeatureTable} from '../../global.styles';

export default ({
  propKey,
  children,
  headers
}: PropsWithChildren<{headers: string[]; propKey: string;}>) => {
  return (
    <FeatureTable role="table">
      <thead>
        <tr role="row">
          {headers.map((header) => {
            return (
              <FeatureHeaderCell
                role="columnheader"
                scope="col"
                key={propKey + '-' + header}
              >
                {header}
              </FeatureHeaderCell>
            );
          })}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </FeatureTable>
  );
};
